export default __webpack_public_path__ + "static/media/wstETH.6015fdce.svg";